import { Button } from '@mui/material';
import { canRegister } from 'domain/event/UnpyEvent.func';
import { KeyValue } from 'primary/Components/KeyValue/KeyValue';
import { routesConfig } from 'primary/Configs/Routes.config';
import {
  getNavigationLinkFromRessourceKey,
  parseRessourceFromNotificaton,
} from 'primary/MessageList/NotificationListItem';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { NotificationResourceTypeEnum } from '../../../domain/notification/NotificationResourceTypeEnum';
import { UnpyNotification } from '../../../domain/notification/UnpyNotification';
import { useContextDependency } from '../../hooks/useContextDependency';
import { useRetrieveFromDomain } from '../../hooks/useRetrieveFromDomain';
import { useTranslate } from '../../hooks/useTranslate';

interface NotificationRefuseEventContentProps {
  notification: UnpyNotification;
  reFetchNotification: () => void;
  closePreview?: () => void;
}

export const NotificationRefuseEventEventContent = ({
  notification,
  reFetchNotification,
  closePreview,
}: NotificationRefuseEventContentProps) => {
  const t = useTranslate();
  const { eventParticipantRepository, eventRepository, authRepository } =
    useContextDependency();
  const navigte = useNavigate();
  const [event, , fetchingEvent] = useRetrieveFromDomain(
    () =>
      eventRepository.getEventById(
        parseInt(notification.resources[NotificationResourceTypeEnum.EVENT_ID]),
      ),
    undefined,
  );

  const ressourcesParsed = parseRessourceFromNotificaton(notification);
  const navigate = useNavigate();

  const isCanRegister = canRegister(event);

  return (
    <div>
      <div className={'-keyValueContainerNotification'}>
        {ressourcesParsed
          .filter((r) => !r.isLink)
          .map((res) => (
            <KeyValue
              key={res.keyValue}
              accent
              keyValue={t(
                `notificationList.item.ressourceLabelByKey.${
                  res.keyValue as NotificationResourceTypeEnum
                }`,
              )}
              value={res.value}
            />
          ))}
      </div>
      <div className={'-linkContainerNotification'}>
        {ressourcesParsed
          .filter((r) => r.isLink)
          .map((res) => (
            <Button
              key={res.keyValue}
              variant={'outlined'}
              className={'-linkNotification'}
              onClick={() => {
                const link = getNavigationLinkFromRessourceKey(
                  res.keyValue as NotificationResourceTypeEnum,
                  res.value,
                  notification.resources,
                );
                navigate(
                  routesConfig.eventViewDetails.eventViewInfos.to(
                    notification.resources[NotificationResourceTypeEnum.EVENT_ID],
                  ),
                );
                closePreview?.();
              }}
            >
              {t(
                `notificationList.item.ressourceLabelByKey.${
                  res.keyValue as NotificationResourceTypeEnum
                }`,
              )}
            </Button>
          ))}
      </div>
    </div>
  );
};
